var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "-1.75 0 32.134 32.134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-610.435 -513.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.641,515.618a.544.544,0,0,1,.544.543v27.048a.544.544,0,0,1-.544.543h-7.663a.543.543,0,0,1-.543-.543V516.161a.543.543,0,0,1,.543-.543h7.663m0-2h-7.663a2.542,2.542,0,0,0-2.543,2.543v27.048a2.542,2.542,0,0,0,2.543,2.543h7.663a2.543,2.543,0,0,0,2.544-2.543V516.161a2.543,2.543,0,0,0-2.544-2.543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.516,515.618a.544.544,0,0,1,.544.543v27.048a.544.544,0,0,1-.544.543h-7.663a.543.543,0,0,1-.543-.543V516.161a.543.543,0,0,1,.543-.543h7.663m0-2h-7.663a2.542,2.542,0,0,0-2.543,2.543v27.048a2.542,2.542,0,0,0,2.543,2.543h7.663a2.543,2.543,0,0,0,2.544-2.543V516.161a2.543,2.543,0,0,0-2.544-2.543Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(611.498 518.125)",
    width: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(627.623 532.125)",
    width: 10.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617,542.179a3.033,3.033,0,1,1,3.033-3.033A3.036,3.036,0,0,1,617,542.179Zm0-4.065a1.033,1.033,0,1,0,1.033,1.032A1.033,1.033,0,0,0,617,538.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.685,542.179a3.033,3.033,0,1,1,3.033-3.033A3.035,3.035,0,0,1,632.685,542.179Zm0-4.065a1.033,1.033,0,1,0,1.033,1.032A1.033,1.033,0,0,0,632.685,538.114Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/TrainingIcon.8f77e2573e67e2209b2f4547d1777568.svg";
export { ForwardRef as ReactComponent };